export default __webpack_public_path__ + "static/media/placeholder-image.cf983e09.svg";